export const REFERRAL_SUGGESTIONS = 'referral suggestions';
export const REFERRAL_LINK_SHARED = 'referral link shared';
export const SEND_REFERRAL_REMINDER_FAILED = 'send referral reminder failed';
export const SEND_REFERRAL_REMINDER = 'send referral reminder';
export const SHOW_MORE_SIGNED_UP_REFERRALS = 'referral signed_up users show';
export const INVITE_USERS = 'invite users';
export const SHOW_MORE_INVITED_REFERRALS = 'referral invited users show';
export const SHOW_MORE_MEMBERS_REFERRALS = 'referral joined users show';
export const SHOW_MORE_CANCELED_REFERRALS = 'referral canceled users show';
export const REFERRALS_PAGE_VIEW = 'referrals';
export const GMAIL_SYNC = 'gmail_sync';
